import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { LoginFormModule } from "./components/login-form/login-form.module";
import { LoginPageComponent } from "./login-page.component";

@NgModule({
  declarations: [LoginPageComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, LoginFormModule],
})
export class LoginPageModule {}
